export default __webpack_public_path__ + "static/media/sample.6193dc95.png";